var _Event_disposed, _Event_eventHandlers;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { AlreadyDisposedException } from '../Exceptions';
import ArgumentException from "../Exceptions/ArgumentException";
/**
 * Class to represent an event.
 */
export default class Event {
    constructor() {
        _Event_disposed.set(this, false);
        _Event_eventHandlers.set(this, []);
    }
    /**
     * Invokes the event
     * @param sender the object that is calling invoke
     * @param args the arguments to send along with the event.
     */
    invoke(sender, args) {
        if (__classPrivateFieldGet(this, _Event_disposed, "f")) {
            throw new AlreadyDisposedException();
        }
        for (const eventHandler of __classPrivateFieldGet(this, _Event_eventHandlers, "f")) {
            if (__classPrivateFieldGet(this, _Event_disposed, "f")) {
                throw new AlreadyDisposedException();
            }
            eventHandler.call(sender, sender, args);
        }
    }
    /**
     * Adds a handler to the event
     * @param eventHandler
     */
    addHandler(eventHandler) {
        if (__classPrivateFieldGet(this, _Event_disposed, "f")) {
            throw new AlreadyDisposedException();
        }
        __classPrivateFieldGet(this, _Event_eventHandlers, "f").push(eventHandler);
        return eventHandler;
    }
    /**
     * removes a handler from the event.
     * @param eventHandler
     */
    removeHandler(eventHandler) {
        if (__classPrivateFieldGet(this, _Event_disposed, "f")) {
            throw new AlreadyDisposedException();
        }
        const index = __classPrivateFieldGet(this, _Event_eventHandlers, "f").indexOf(eventHandler);
        if (index != -1) {
            __classPrivateFieldGet(this, _Event_eventHandlers, "f").splice(index, 1);
        }
        else {
            throw new ArgumentException('eventHandler', "Handler is not in this Event");
        }
    }
    dispose() {
        if (!__classPrivateFieldGet(this, _Event_disposed, "f")) {
            __classPrivateFieldSet(this, _Event_disposed, true, "f");
            __classPrivateFieldGet(this, _Event_eventHandlers, "f").length = 0;
        }
    }
}
_Event_disposed = new WeakMap(), _Event_eventHandlers = new WeakMap();
